
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"34","height":"34","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#245389","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/forbidden"}},[_c('path',{attrs:{"d":"M21.11 2.827h-8.22a4.925 4.925 0 00-3 1.247L4.074 9.885a4.925 4.925 0 00-1.247 3v8.22a4.925 4.925 0 001.247 3l5.811 5.822a4.925 4.925 0 003 1.247h8.22a4.925 4.925 0 003-1.247l5.822-5.813a4.925 4.925 0 001.247-3v-8.22a4.925 4.925 0 00-1.247-3l-5.813-5.82a4.925 4.925 0 00-3.004-1.247z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M6.984 27.045L27.045 6.984","opacity":".4"}})])])
          )
        }
      }
    